/**
 * Lista os contatos de emergência ativos (cadeia PAEBM) — GUPM-158.
 * Alimenta o modal de contatos do Header.
 *
 * Regra #2: leitura via datasource `contatos`, nunca `supabase.from` na UI.
 * `contacts` é 🟠 sensível — RLS garante leitura só a autenticado.
 */
import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';

/** `habilitado = false` evita a consulta (a aba Contatos do admin lê tudo de `listParaGestao`, C-75). */
export function useContatosEmergencia(habilitado = true) {
  const { contatos } = useDataSources();
  return useQuery({
    queryKey: ['contatos', 'emergencia'],
    enabled: habilitado,
    staleTime: 30 * 60 * 1000,
    queryFn: () => contatos.listAtivos(),
  });
}
